"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGEX = void 0;
exports.REGEX = {
    PRICE_NUMBER: /^\d+(\.\d{1,2})?$/,
};
